const modal = (trigerSelector,closeSelector,overlaySelector,windowSelector,active) => {
    const triger = document.querySelector(trigerSelector),
          close = document.querySelector(closeSelector),
          overlay = document.querySelector(overlaySelector),
          windowModal = document.querySelector(windowSelector);

    triger.addEventListener('click', e => {
        e.preventDefault();

        overlay.style.display = 'flex';
        setTimeout( () => {
            windowModal.classList.add(active);
        }, 200);
    });

    close.addEventListener('click', () => {
        windowModal.classList.remove(active);
        setTimeout( () => {
            overlay.style.display = 'none';
        }, 800);
    });

    overlay.addEventListener('click', e => {
        if (e.target.classList.contains('overlay')) {
            windowModal.classList.remove(active);
            setTimeout( () => {
                overlay.style.display = 'none';
            }, 800);
        }
    });
};

export default modal;